var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.maskVisible
    ? _c("div", { staticClass: "website-modal" }, [
        _c("div", { staticClass: "mask" }, [
          _c(
            "div",
            { staticClass: "form-section" },
            [
              _vm.showRegisterForm
                ? _c("RegisterForm", {
                    attrs: { accept: _vm.acceptPrivacy },
                    on: {
                      "on-submit": _vm.handleRegisterSubmit,
                      "on-login": _vm.handleLogin,
                      "on-close": _vm.handleFormClose,
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "privacy",
                          fn: function () {
                            return [
                              _c("PrivacyPolicy", {
                                on: { "on-change": _vm.handleAgreement },
                              }),
                            ]
                          },
                          proxy: true,
                        },
                      ],
                      null,
                      false,
                      1016752067
                    ),
                  })
                : _c("EnterpriseCertification", {
                    on: { "on-close": _vm.handleFormClose },
                  }),
            ],
            1
          ),
        ]),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }